import { MenuItem, Select } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import IconArrow from "../../assets/images/icon-arrow-4.svg"

const Container = styled.div`
    width: 100%;
    height: 48px;

    .label-show {
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
        margin-right: 16px;
    }

    .dropdown {
        height: 40px;
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
    }

    .paginator-box {
        height: 36px;
        margin-right: 0px;
        margin-left: auto;

        .arrow-box {
            width: 24px;
            height: 24px;
            border-radius: 8px;
            transition: all 0.2s ease;

            &.normal {
                cursor: pointer;

                &:hover {
                    background-color: #FBE25099;
                }
            }

            &.disable {
                cursor: default;
            }

            .img-last {
                transform: rotateY(180deg);
            }
        }

        .page-box {
            gap: 4px;
            margin: 0px 8px;

            .page {
                width: 36px;
                height: 36px;
                border-radius: 8px;
                font-family: Kanit;
                color: #838BB4;
                font-size: 15px;
                font-weight: 400;
                line-height: 22.43px;
                text-align: left;
                cursor: pointer;
                transition: all 0.2s ease;

                &.active {
                    color: #25368D;
                    font-size: 15px;
                    font-weight: 400;
                    line-height: 22.43px;
                    text-align: left;
                    background-color: #FBE250;
                }

                &:hover {
                    background-color: #FBE25099;
                }
            }
        }
    }
`;

function PaginatorComponent({
    limit,
    page,
    total_item,
    total_page,
    onChangePageOption,
}) {
    const [pageOption, setPageOption] = useState({
        limit: 10,
        page: 1,
        total_item: 1,
        total_page: 1,
    });
    const [listPage, setListPage] = useState([])

    useEffect(() => {
        let detail = {
            limit: 10,
            page: 1,
            total_item: 1,
            total_page: 1,
        }
        if (limit) {
            detail.limit = limit;
        }
        if (page) {
            detail.page = page;
        }
        if (total_item) {
            detail.total_item = total_item;
        }
        if (total_page) {
            detail.total_page = total_page;
        }
        setPageOption(detail);
    }, [limit, page, total_item, total_page])
    useEffect(() => {
        onSetListPage(pageOption)
    }, [pageOption])

    function onSetListPage(params) {
        let max_show = 5;
        if ((max_show % 2) === 0) {
            max_show = Math.ceil(max_show / 2);
        }
        const position_between = max_show - Math.trunc(max_show / 2) - 1;
        const current_show = params.total_page < max_show ? params.total_page : max_show;
        const current_page = params.page;
        const _total_page = params.total_page;
        let list = [];
        for (let i = 0; i < current_show; i++) {
            if (current_show === max_show) {
                if (current_page <= 2) {
                    list.push(i + 1)
                } else if ((current_page + position_between) > _total_page) {
                    list.push(i + (_total_page - max_show) + 1)
                } else {
                    list.push(i + (current_page - position_between))
                }
            } else {
                list.push(i + 1)
            }
        }
        setListPage(list);
    }

    function handleChangePage(param) {
        let detail = { ...pageOption };
        detail.page = param;
        // ========== ========== ========== ==========
        detail.limit = Number(detail.limit);
        detail.page = Number(detail.page);
        detail.total_item = Number(detail.total_item);
        detail.total_page = Number(detail.total_page);
        // ========== ========== ========== ==========
        setPageOption(detail);
        onChangePageOption && onChangePageOption(detail)
    }
    function handleChangeLimit(event) {
        const value = event.target.value;
        let detail = { ...pageOption };
        detail.limit = value;
        detail.page = 1;
        // ========== ========== ========== ==========
        detail.limit = Number(detail.limit);
        detail.page = Number(detail.page);
        detail.total_item = Number(detail.total_item);
        detail.total_page = Number(detail.total_page);
        // ========== ========== ========== ==========
        setPageOption(detail);
        onChangePageOption && onChangePageOption(detail)
    }
    function handleClickNext() {
        if (pageOption.page === pageOption.total_page) return;
        let detail = { ...pageOption };
        detail.page = detail.page + 1;
        // ========== ========== ========== ==========
        detail.limit = Number(detail.limit);
        detail.page = Number(detail.page);
        detail.total_item = Number(detail.total_item);
        detail.total_page = Number(detail.total_page);
        // ========== ========== ========== ==========
        setPageOption(detail);
        onSetListPage(detail)
        onChangePageOption && onChangePageOption(detail)
    }
    function handleClickBack() {
        if (pageOption.page === 1) return;
        let detail = { ...pageOption };
        detail.page = detail.page - 1;
        // ========== ========== ========== ==========
        detail.limit = Number(detail.limit);
        detail.page = Number(detail.page);
        detail.total_item = Number(detail.total_item);
        detail.total_page = Number(detail.total_page);
        // ========== ========== ========== ==========
        setPageOption(detail);
        onSetListPage(detail)
        onChangePageOption && onChangePageOption(detail)
    }

    return (
        <Container className="vertical-center">
            <div className="label-show">Showing</div>
            <Select
                className={`dropdown`}
                value={pageOption.limit}
                onChange={handleChangeLimit}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
            >
                <MenuItem value={"5"}>5</MenuItem>
                <MenuItem value={"10"}>10</MenuItem>
                <MenuItem value={"20"}>20</MenuItem>
                <MenuItem value={"50"}>50</MenuItem>
                <MenuItem value={"100"}>100</MenuItem>
            </Select>
            <div className="paginator-box vertical-center">
                <div className={`arrow-box content-center ${pageOption.page === 1 ? "disable" : "normal"}`}
                    onClick={handleClickBack}
                >
                    <img alt="img" src={IconArrow} />
                </div>
                <div className="page-box vertical-center">
                    {listPage.map((value, index) => {
                        return (
                            <div key={index}
                                className={`content-center page ${pageOption.page === value ? "active" : ""}`}
                                onClick={(e) => handleChangePage(value)}
                            >
                                {value}
                            </div>
                        )
                    })}
                </div>
                <div className={`arrow-box content-center ${pageOption.page === pageOption.total_page ? "disable" : "normal"}`}
                    onClick={handleClickNext}
                >
                    <img className="img-last" alt="img" src={IconArrow} />
                </div>
            </div>
        </Container>
    )
}

export default PaginatorComponent;